import React from 'react';
import { m } from 'framer-motion';
import { CalendarIcon, SmartphoneIcon, CheckIcon, XIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { StarRating } from '../ui/StarRating';
import { ScrollHintTable } from '../ui/ScrollHintTable';
const comparison = [{
  without: 'Tienes 180 sesiones sin orden',
  withKit: 'Tienes 180 sesiones con un mapa'
}, {
  without: 'Cada domingo decides qué hacer',
  withKit: 'Cada domingo confirmas lo que ya está decidido'
}, {
  without: 'Buscas en el PDF entre páginas',
  withKit: 'Encuentras la ficha en 10 segundos'
}, {
  without: 'Avanzas por intuición',
  withKit: 'Avanzas con criterio pedagógico real'
}, {
  without: 'El manual se usa a medias',
  withKit: 'El manual se usa al 100%'
}];
const pocketChecks = ['Objetivo del ejercicio en una línea.', 'Organización exacta del grupo.', 'La consigna clave que activa el aprendizaje.', 'La señal de éxito para saber cuándo avanzar.', 'Índice de búsqueda por fundamento, formato y situación de partido.'];
export function KitUpsell() {
  return <section className="bg-bg-secondary py-10 sm:py-14" data-id="element-173" data-mp="1xch4pzlfdnnb">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-174" data-mp="1xcz77dyoky3o">
        <h2 className="font-heading text-2xl font-bold uppercase leading-tight text-white sm:text-3xl" data-id="element-175" data-mp="22bahfpsw1amf">
          ¿Ya tienes el Manual Base? Lleva tu temporada al siguiente nivel.
        </h2>
        <div className="mx-auto mt-6 max-w-2xl space-y-3 text-left text-base leading-relaxed text-muted sm:text-center" data-id="element-176" data-mp="2ca9hwl3i1zyc">
          <p data-id="element-177" data-mp="2ga9x47yfaf6g">Hay algo que la mayoría de entrenadores descubren demasiado tarde.</p>
          <p data-id="element-178" data-mp="2l1rukm18lxmo">Tener 180 sesiones es increíble.</p>
          <p data-id="element-179" data-mp="2l44n1t4mfqdz">
            Pero hay un problema que nadie te dice: el problema no es tener las sesiones. Es saber cuál de
            esas 180 sesiones toca exactamente hoy.
          </p>
          <p data-id="element-180" data-mp="2v22a4daqvh50">¿La del bote o la de la zona? ¿El contraataque o el espaciado? ¿Ya vimos el bloqueo directo o todavía no?</p>
          <p data-id="element-181" data-mp="2zwy1db85q0h2">
            Sin un sistema de organización, hasta el mejor manual del mundo puede convertirse en una
            biblioteca que nunca usas del todo bien.
          </p>
          <p className="font-semibold text-white" data-id="element-182" data-mp="25dwttdks7wq6">Por eso creamos el KIT DE IMPLEMENTACIÓN TOTAL.</p>
        </div>
      </div>

      <div className="mx-auto mt-8 max-w-4xl px-4 sm:px-6" data-id="element-183" data-mp="2fa9ooes2cgmi">
        <div className="text-center" data-id="element-184" data-mp="2f8ouiq9nuzp6">
          <SectionTag icon="💎" data-id="element-185" data-mp="2t1o5qg2eu7qx">Kit de Implementación Total</SectionTag>
          <p className="mx-auto mt-4 max-w-xl text-base text-muted sm:text-lg" data-id="element-186" data-mp="2sztnj9iiwtqj">
            El sistema que convierte el manual en una temporada perfectamente planificada y ejecutada.
          </p>
        </div>

        <div className="mt-6 space-y-4" data-id="element-187" data-mp="32xhses9ufhmf">
          <m.div initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.45
        }} className="rounded-2xl border border-white/10 bg-bg-primary p-6 sm:p-8" data-id="element-188" data-mp="2y0hn4jktiiwd">
            <div className="flex items-center gap-3" data-id="element-189" data-mp="3f9juuc4gh07q">
              <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-orange/10" data-id="element-190" data-mp="3fav6sz821e9x">
                <CalendarIcon size={22} className="text-orange" data-id="element-191" data-mp="3k8dcmgqrzddp" />
              </div>
              <h3 className="font-heading text-lg font-semibold text-white sm:text-xl" data-id="element-192" data-mp="35jqu665uq5i9">
                Herramienta 1: El Cronograma Maestro Anual
              </h3>
            </div>
            <p className="mt-4 text-sm text-muted" data-id="element-193" data-mp="2wij0y2i6zuv1">
              Imagina abrir un documento el domingo por la noche y ver exactamente esto:
            </p>
            <blockquote className="mt-3 rounded-xl border-l-2 border-orange/40 bg-white/5 p-4 text-sm italic leading-relaxed text-white/90" data-id="element-194" data-mp="2mleb9sp51h9h">
              "Semana 14. Período de Competición. Martes → Tomo 4, Sesión 3. Jueves → Bono 3, Situación 12.
              Objetivo de la semana: que el equipo comunique el bloqueo antes de que llegue."
            </blockquote>
            <p className="mt-4 text-sm leading-relaxed text-white/90" data-id="element-195" data-mp="pscp63vg0u7s">
              Eso es el Cronograma Maestro. 36 semanas de temporada completamente planificadas. Septiembre a
              Junio. Con los objetivos de cada semana, las sesiones exactas de cada entrenamiento y la señal
              que te indica cuándo estás listo para avanzar al siguiente nivel.
            </p>
            <p className="mt-2 text-sm text-muted" data-id="element-196" data-mp="27vzn4qubb924">
              Para equipos de 2 días por semana y para equipos de 3 días por semana.
            </p>
            <p className="mt-2 text-sm font-semibold text-orange" data-id="element-197" data-mp="1y6y8p53f0zq9">
              No vuelves a preguntarte qué toca el martes. Nunca más.
            </p>
          </m.div>

          <m.div initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.45,
          delay: 0.08
        }} className="rounded-2xl border border-white/10 bg-bg-primary p-6 sm:p-8" data-id="element-198" data-mp="1t5ikj45xyd3n">
            <div className="flex items-center gap-3" data-id="element-199" data-mp="1f9wzt96qqfh1">
              <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-orange/10" data-id="element-200" data-mp="3qu4cc9d7bf9b">
                <SmartphoneIcon size={22} className="text-orange" data-id="element-201" data-mp="3vt7jbzcqrvjx" />
              </div>
              <h3 className="font-heading text-lg font-semibold text-white sm:text-xl" data-id="element-202" data-mp="4npmawfb3671">
                Herramienta 2: La Versión Pocket "Fast-Track"
              </h3>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-white/90" data-id="element-203" data-mp="3857s6ybiq34t">
              El momento más incómodo de cualquier entrenador: estar en la línea de banda con el móvil
              intentando encontrar el ejercicio correcto mientras el grupo espera.
            </p>
            <p className="mt-2 text-sm font-semibold text-orange" data-id="element-204" data-mp="3h3jcyjppe6pc">
              La Versión Pocket resuelve ese problema para siempre.
            </p>
            <p className="mt-3 text-sm text-muted" data-id="element-205" data-mp="2pd59lhfbgcrx">
              Es el manual entero destilado en 80+ fichas de consulta rápida diseñadas para leer en 10
              segundos bajo los focos del pabellón:
            </p>
            <ul className="mt-4 space-y-2" data-id="element-206" data-mp="jgsp6jyi0qz">
              {pocketChecks.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-relaxed text-white/90" data-id="element-207" data-mp="3rr327ftcwxfr">
                  <CheckIcon size={16} className="mt-0.5 flex-shrink-0 text-success" data-id="element-208" data-mp="aabek9taiybw" />
                  {item}
                </li>)}
            </ul>
          </m.div>
        </div>

        <div className="mt-8" data-id="element-209" data-mp="3dsd2dsf5kjnp">
          <h3 className="text-center font-heading text-xl font-semibold text-white sm:text-2xl" data-id="element-210" data-mp="38sqg6thcjt2r">
            Por qué el Kit no es un extra. Es la pieza que faltaba.
          </h3>
          <div className="mt-6" data-id="element-211" data-mp="3mqf09z3law6r">
            <ScrollHintTable minWidth="560px" data-id="element-212" data-mp="3ir66wvcgp0bq">
              <table className="w-full text-left text-sm" data-id="element-213" data-mp="3ipd1tkhhyo5u">
                <thead data-id="element-214" data-mp="121r8yq139pco">
                  <tr className="border-b border-white/10 bg-white/5 text-xs uppercase tracking-wide text-muted" data-id="element-215" data-mp="120zejij89xnz">
                    <th className="px-5 py-3 font-semibold" data-id="element-216" data-mp="y05uj08wp30d">Sin el Kit</th>
                    <th className="px-5 py-3 font-semibold" data-id="element-217" data-mp="15j6lyn6fn67d">Con el Kit</th>
                  </tr>
                </thead>
                <tbody data-id="element-218" data-mp="1akvzqal1hxz5">
                  {comparison.map((row, i) => <tr key={row.without} className={i !== comparison.length - 1 ? 'border-b border-white/5' : ''} data-id="element-219" data-mp="vn3nbrashpp6" data-mpi={i}>
                      <td className="px-5 py-3.5" data-id="element-220" data-mp="10lna1tx7j5il">
                        <span className="flex items-start gap-2 text-muted" data-id="element-221" data-mp="1oazgwn52b1hq">
                          <XIcon size={14} className="mt-0.5 flex-shrink-0 text-danger" data-id="element-222" data-mp="1od24z1mnmkjt" />
                          {row.without}
                        </span>
                      </td>
                      <td className="px-5 py-3.5" data-id="element-223" data-mp="1ekmoy9ux461k">
                        <span className="flex items-start gap-2 text-white/90" data-id="element-224" data-mp="1jj7oe72ciloy">
                          <CheckIcon size={14} className="mt-0.5 flex-shrink-0 text-success" data-id="element-225" data-mp="279tuhssshvwb" />
                          {row.withKit}
                        </span>
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </ScrollHintTable>
          </div>
        </div>

        <div className="mt-6 grid gap-4 sm:grid-cols-2" data-id="element-226" data-mp="76ixr3fh7ift">
          {[{
          text: 'El Cronograma Maestro es lo que hace que todo encaje. Antes tenía los tomos pero no sabía cuándo usar cada uno. Ahora sigo el mapa y el equipo progresa de manera visible cada semana.',
          name: 'Tomás V.',
          role: 'Entrenador Infantil · Alicante'
        }, {
          text: 'La Versión Pocket me parece un lujo. La tengo en el móvil y cuando necesito recordar la consigna clave de un ejercicio la encuentro en 5 segundos. Sin interrumpir el entrenamiento.',
          name: 'Elena M.',
          role: 'Monitora Premini y Mini · Salamanca'
        }].map(t => <div key={t.name} className="rounded-2xl border border-white/10 bg-bg-primary p-5" data-id="element-227" data-mp="36k35awu6t8ll">
              <StarRating size={14} data-id="element-228" data-mp="31ppgjda15zpw" />
              <p className="mt-3 text-sm leading-relaxed text-white/90" data-id="element-229" data-mp="2rk7dxi66a7oj">"{t.text}"</p>
              <p className="mt-3 text-sm font-semibold text-white" data-id="element-230" data-mp="2wi96qutehld7">{t.name}</p>
              <p className="text-xs text-muted" data-id="element-231" data-mp="2wg66lhyjabur">{t.role}</p>
            </div>)}
        </div>
      </div>
    </section>;
}